<template>
  <div class="app-page">
    <slot />
  </div>
</template>

<script>
/**
 * Page content wrapper for topbar-only layouts (no sidebar).
 *
 * Guarantees equal padding on all four edges so any content dropped inside
 * sits at a consistent, professional gutter — regardless of the page. Use as
 * the outermost wrapper of a view's content (siblings: the global topbar).
 *
 * Content-only: it renders no chrome (topbar lives elsewhere), stays full
 * width, and carries no background so it inherits the app page surface.
 *
 * For pages that also have a left sidebar, use <app-page-sidebar> instead.
 */
export default {
  name: 'AppPage',
}
</script>

<style scoped lang="scss">
// Self-contained tokens — keep the component portable (mirrors the admin
// $ad-* spacing without importing the dashboard theme module).
$app-pad:    24px;
$app-pad-sm: 16px;
$app-bp-sm:  768px;

.app-page {
  box-sizing: border-box;
  width: 100%;
  padding: $app-pad;
}

// Tighter gutter on phones/small tablets, still equal on all four edges.
@media (max-width: $app-bp-sm) {
  .app-page {
    padding: $app-pad-sm;
  }
}
</style>
